export const COLORS = {
  deepGray: "#9B9B9B",
  deepGray2: "#bebebe",
  lightBlack: "#464646",
  lightBlack2: "#d2d2d2",
  lightGray: "#DBDBDB",
  lightGray2: "#dcdcdc",
  lightGray3: "#efefef",
  whiteGray: "#F7F7F7",
  lineChartLineColor: "#8884d8",
  chartGridLineColor: "#b4b4b4",
  lightFontColor: "#848484",
  darkFontColor: "#494949",
  darkRed: "#800000",
  darkRed2: "#B90000",
  lightRed: "#d69898",
  fontColor: "#696969",
  modalBackGroundColor: "#00000010",
  yellow: "#ffd050",
  lightOrange: "#f7c211",
  lightOrange2: "#fff2cf",
  warningRed: "#d90404",
  gray: "#4E535A",
  gray2: "#52565E",
  purple: "#6131b5",
  purple2: "#c8bae0",
};

export const CLOUDN_COLORS = {
  logoBlue: "#3270B5",
  logoSkyBlue: "#57B5CF",
  skyBlue: "#a0c8de",
  deepNavy: "#0f2530",
};

export const CONDITION_COLORS = {
  good: "#4090F7",
  normal: "#8ec949",
  bad: "#ffa933",
  veryBad: "#d62222",
};
export const CONDITION_COLORS_FONT = {
  good: "#64C7FA",
  normal: "#8ec949",
  bad: "#ffa933",
  veryBad: "#d62222",
};

export const STATE_COLORS = {
  normal: "#6495ed",
  normalOpacity: "#6494ed7c",
  care: "#33ae22",
  careOpacity: "#32ae223a",
  caution: "#ffd112",
  cautionOpacity: "#ffd0124c",
  warning: "#ff8512",
  warningOpacity: "#ff851241",
  danger: "#c31e1e",
  dangerOpacity: "#b0191933",
};

export const FIRE_STATE_COLORS = {
  normal: "#8ec949",
  warning: "#ffa933",
  fire: "#D93933",
  disconnected: "#bebebe",
};

export const CHART_COLORS = [
  "#6495ED", // CornflowerBlue
  "#9ACD32", // YellowGreen
  "#F2B150", // Lavender
  "#87CEFA", // LightSkyBlue
  "#9370DB", // MediumPurple
  "#98FB98", // PaleGreen
  "#F08080", // LightCoral
  "#6A5ACD", // SlateBlue
];

export const EMART_COLORS = {
  lightYellow: "#f8e494",
  lightYellow2: "#FAFAD2",
  lightOrange: "#FDF5E6",
  deepYellow: "#ffd050",
  deepYellow2: "#FFDC3C",
  fontYellow: "#f0b800",
  darkYellow: "#8f742c",
  orange: "#F3A761",
  redOrange: "#FE6424",
  logoYellow: "#EAAE41",
};

export const GROUP_COLORS = {
  emart: "#EAAE41",
  bjc: "#97bf10",
  depa: "#172B4F",
  hyundai: "#102E67",
};
